module.exports = __webpack_public_path__ + "static/media/PRISM_4562.db956c4d.jpg";